import {FC} from "react";
import {Routes, Route, Navigate,useNavigate} from "react-router-dom";
import Home from "./components/Home";
import JPGToPDFConverter from "./components/JPGToPDFConverter";
import HEICToJPGConverter from "./components/HEICToJPGConverter";
import MergePdf from "./components/MergePdf";
import UniversalFileGenerator from "./components/UniversalFileGenerator";
import Base64Encoder from "./components/Base64Encoder";
import JWTEncoder from "./components/JWTEncoder";
import Editor from "./components/Editor";
import SpreadsheetEditor from "./components/SpredsheetEditor";
import PdfEditor from "./components/PdfEditor";
import PptEditor from "./components/PptEditor";




const App: FC = () => {
    const navigate = useNavigate();
    return (
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/jpg-to-pdf" element={<JPGToPDFConverter onBack={() => navigate("/home")}/>}/>
            <Route path="/heic-to-jpg" element={<HEICToJPGConverter onBack={() => navigate("/home")}/>}/>
            <Route path="/merge-pdf" element={<MergePdf onBack={() => navigate("/home")}/>}/>
            <Route path="/generate-files" element={<UniversalFileGenerator onBack={() => navigate("/home")}/>}/>
            <Route path="/jwt-token" element={<JWTEncoder onBack={() => navigate("/home")}/>}/>
            <Route path="/base64-encoder" element={<Base64Encoder onBack={() => navigate("/home")}/>}/>
            <Route path="/edit-doc" element={<Editor onBack={() => navigate("/home")}/>}/>
            <Route path="/edit-spread-sheet" element={<SpreadsheetEditor onBack={() => navigate("/home")}/>}/>
            <Route path="/edit-pdf" element={<PdfEditor onBack={() => navigate("/home")}/>}/>
            <Route path="/edit-ppt" element={<PptEditor onBack={() => navigate("/home")}/>}/>
            <Route path="/home" element={<Navigate to="/" replace/>}/>
        </Routes>
    );
};

export default App;

